module.exports = __webpack_public_path__ + "img/training_m.758dd219.svg";